import { ContentItem } from '..';

export class TextContentItem extends ContentItem {
  title: string = '';
  text: string = '';

  constructor(json: any) {
    super();
    this._type = 'text';
    if (json.title) this.title = json.title;
    if (json.text) this.text = json.text;
  }

  copy() {
    return new TextContentItem(this.toJson());
  }

  toJson() {
    return {
      content_type: 'text',
      title: this.title,
      text: this.text
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/text-content-item.model.ts